/* eslint-disable no-undef */
import * as dat from 'lil-gui';
import Stats from 'stats.js';

export default class Debug {
    constructor() {
        // Understand if the url has #debug in the end.
        // this.active = window.location.hash === '#debug';
        this.active = false;

        if (this.active) {
            this.ui = new dat.GUI();
            this.stats = new Stats();
            document.body.appendChild(this.stats.dom);
        }
    }

    update() {
        if (this.active) this.stats.update();
    }
}
